var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrayGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 11338"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.16453 8.09534C4.02245 6.42115 5.33857 5.01376 6.96579 4.03047C8.593 3.04719 10.4672 2.52675 12.3789 2.52734C15.1578 2.52734 17.4923 3.52777 19.2773 5.15977L16.321 8.05795C15.2517 7.05652 13.8926 6.54621 12.3789 6.54621C9.69273 6.54621 7.41905 8.32473 6.6096 10.7126C6.40337 11.3189 6.28582 11.9657 6.28582 12.6326C6.28582 13.2996 6.40337 13.9463 6.6096 14.5526C7.42008 16.9415 9.69273 18.719 12.3789 18.719C13.7658 18.719 14.9464 18.3603 15.8703 17.754C16.406 17.4084 16.8645 16.9599 17.2183 16.4357C17.572 15.9115 17.8136 15.3225 17.9285 14.7042H12.3789V10.7955H22.0902C22.2119 11.4564 22.2779 12.1455 22.2779 12.862C22.2779 15.9401 21.154 18.531 19.203 20.2894C17.4975 21.8334 15.163 22.7379 12.3789 22.7379C11.0246 22.7384 9.68349 22.4774 8.4322 21.9697C7.1809 21.4621 6.04396 20.7178 5.08634 19.7793C4.12872 18.8408 3.3692 17.7266 2.8512 16.5004C2.33319 15.2741 2.06684 13.9598 2.06738 12.6326C2.06738 11.0016 2.46541 9.45955 3.16453 8.09534Z",
    fill: "#9E9E9E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayGoogleIcon);
export default __webpack_public_path__ + "static/media/gray_google_icon.ebf44ad80f988cbf0931a715038f9d8d.svg";
export { ForwardRef as ReactComponent };